// extracted by mini-css-extract-plugin
module.exports = {"bkw-P":"P_bkw-P__W1KgE"};